<script lang="ts">
	//Hooks
	import { createEventDispatcher, onDestroy } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Helpers
	import { click_outside } from '../../../helpers/touch_handler';
	//Design system components
	import { Icon } from '@Shelly/shelly-design-system';

	export let expanded = false,
		debounceTimeout = 250;

	export const open = () => {
			expanded = true;
			inputField.focus();
		},
		close = () => {
			expanded = false;
			clearTimeout(timeoutId);
			inputField.value = '';
			inputField.blur();
		};

	let timeoutId: NodeJS.Timeout, inputField: HTMLInputElement;

	const dispatch = createEventDispatcher(),
		onInputHandler = (e) => {
			clearTimeout(timeoutId);
			timeoutId = setTimeout(() => {
				dispatch('input', e.target.value);
			}, debounceTimeout);
		};

	onDestroy(() => {
		clearTimeout(timeoutId);
	});
</script>

<div class:expanded class="input-wrapper" use:click_outside={true} on:click_outside>
	<div class="search-field-box">
		<Icon size="s" icon="fas fa-search" />
		<input
			type="text"
			placeholder={$format('search_for_location', {
				default: 'Search for location',
			})}
			autocomplete="off"
			on:focus={() => (expanded = true)}
			on:input={onInputHandler}
			bind:this={inputField}
		/>
	</div>
	<slot />
</div>

<style>
	.input-wrapper {
		position: absolute;
		top: 15px;
		left: 15px;
		z-index: 4;
		background: var(--color-base);
		border-radius: var(--radius-small);
		overflow: hidden;
		width: 220px;
		border: 1px solid var(--color-3);
		max-height: calc(100% - 20px);
		display: flex;
		flex-direction: column;
	}
	.input-wrapper.expanded {
		box-shadow: var(--shadow-glow-soft);
		border: 1px solid var(--color-primary);
	}
	.search-field-box {
		display: flex;
		justify-content: center;
		align-items: center;
		background: var(--color-base);
	}
	input {
		position: relative;
		height: 32px;
		opacity: 0;
		width: 0;
		position: relative;
		margin: 0;
		padding: 0;
		border: none;
		outline: none;
		transition: width 0.33s;
		color: var(--color-white);
		background: var(--color-base);
		border-radius: var(--radius-small);
		border-left: none;
		font-family: var(--font-family);
		font-size: 13px;
		line-height: 16px;
	}

	input::placeholder {
		color: var(--color-3);
		font-family: var(--font-family);
		font-size: 13px;
		line-height: 16px;
	}
	.input-wrapper input {
		opacity: 1;
		position: relative;
		padding: 0 10px 0 5px;
		width: 190px;
	}
</style>
